import React, {Component} from 'react'
import {FormattedDate, FormattedMessage} from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx";

class QuoteStatusTimeLine extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            quote: this.props.quote || null,
            className: this.props.className || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            quote: nextProps.quote || null,
        })
    }

    render() {

        const step3 = {
            disabled: true,
            icon: 'circle',
            iconClass: '',
            text: <FormattedMessage
                id="quote.edit.workflow.not_accepted_label"
                defaultMessage="Not accepted"
            />
        }
        const step4 = {
            disabled: true,
            icon: 'circle',
            iconClass: '',
            text: <FormattedMessage
                id="quote.edit.workflow.not_approved_label"
                defaultMessage="Not approved"
            />
        }


        let currentStep = {
            disabled: false,
            icon: 'check-circle',
            iconClass: '',
            text: <FormattedMessage
                id="quote.edit.workflow.proposed_on_label"
                defaultMessage="Proposed on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.quote.attributes.proposedAt)}/>
                }}
            />
        }

        if (this.state.quote.attributes.preApprovedAt) {
            step3.disabled = false
            step3.icon = 'check-circle'
            step3.text = <FormattedMessage
                id="quote.edit.workflow.accepted_on_label"
                defaultMessage="Accepted on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.quote.attributes.preApprovedAt)}/>
                }}
            />
        }
        if (this.state.quote.attributes.preDeclinedAt) {
            step3.disabled = false
            step3.icon = 'times-circle'
            step3.iconClass = 'text-secondary'
            step3.text = <FormattedMessage
                id="quote.edit.workflow.pre_declined_on_label"
                defaultMessage="Declined on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.quote.attributes.preDeclinedAt)}/>
                }}
            />
        }

        if (this.state.quote.attributes.approvedAt) {
            step4.disabled = false
            step4.icon = 'check-circle'
            step4.text = <FormattedMessage
                id="quote.edit.workflow.approved_on_label"
                defaultMessage="Approved on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.quote.attributes.approvedAt)}/>
                }}
            />
            if (!this.state.quote.attributes.preApprovedAt && !this.state.quote.attributes.preDeclinedAt) {
                step3.disabled = false
            }
        }


        if (this.state.quote.attributes.declinedAt) {
            step4.disabled = false
            step4.icon = 'times-circle'
            step4.iconClass = 'text-secondary'
            step4.text = <FormattedMessage
                id="quote.edit.workflow.declined_on_label"
                defaultMessage="Declined on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.quote.attributes.declinedAt)}/>
                }}
            />
            if (this.state.quote.attributes.preDeclinedAt) {
                step4.text = <FormattedMessage
                    id="quote.edit.workflow.acknowledged_on_label"
                    defaultMessage="Acknowledged on {date}"
                    values={{
                        date: <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(this.state.quote.attributes.declinedAt)}/>
                    }}
                />
            }
            if (!this.state.quote.attributes.preApprovedAt && !this.state.quote.attributes.preDeclinedAt) {
                step3.disabled = false
            }
        }

        if (!step3.disabled) {
            currentStep = step3
        }
        if (!step4.disabled) {
            currentStep = step4
        }

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <div className={"row px-3"}>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}> </div>
                                <Icon className={"px-2 workflow-icon"} value={"check-circle"}/>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                <FormattedMessage
                                    id="quote.edit.workflow.created_on_label"
                                    defaultMessage="Created on {date}"
                                    values={{
                                        date: <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(this.state.quote.attributes.createdAt)}/>
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                                <Icon className={"px-2 workflow-icon"} value={"check-circle"}/>
                                <div className={"flex-fill"}><hr className={"workflow-line"} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                <FormattedMessage
                                    id="quote.edit.workflow.proposed_on_label"
                                    defaultMessage="Proposed on {date}"
                                    values={{
                                        date: <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(this.state.quote.attributes.proposedAt)}/>
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step3.disabled ? 'disabled' : '')} /></div>
                                <Icon className={"px-2 workflow-icon " + step3.iconClass + (step3.disabled ? ' disabled' : '')} value={step3.icon}/>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step3.disabled ? 'disabled' : '')} /></div>
                            </div>
                            <div className={"col-12 text-center"}>
                                {step3.text}
                            </div>
                        </div>
                    </div>
                    <div className={"col-3 p-0 d-none d-md-block"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex align-items-center"}>
                                <div className={"flex-fill"}><hr className={"workflow-line " + (step4.disabled ? 'disabled' : '')} /></div>
                                <Icon className={"px-2 workflow-icon "+ step4.iconClass + (step4.disabled ? ' disabled' : '')} value={step4.icon}/>
                                <div className={"flex-fill"}> </div>
                            </div>
                            <div className={"col-12 text-center"}>
                                {step4.text}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row px-3 d-block d-md-none"}>
                    <div className={"col-12 p-0"}>
                        <div className={"row"}>
                            <div className={"col-12 d-flex justify-content-center"}>
                                <Icon className={"px-2 workflow-icon "+ currentStep.iconClass + (currentStep.disabled ? ' disabled' : '')} value={currentStep.icon}/>
                            </div>
                            <div className={"col-12 text-center"}>
                                {currentStep.text}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default QuoteStatusTimeLine





// WEBPACK FOOTER //
// ./src/quote/analytics/statustimeline.component.jsx